<template>
    <div style="color: darkgreen">
        <a :href="'/kontrahenty/' + cont_id" target="_blank" v-if="has_user">
            Учасник: {{this.user?.company}} ({{this.user.contact_name}} {{this.user.contact_tel}})
        </a>
    </div>
</template>


<script>
export default {
    name: "application_contragent",
    props : {
        tender : {
            type : Object,
            required : true
        }
    },
    
    computed : {
        request() {
            return this.tender.request;
        },
        
        contragent() {
            return this.request?.contragent;
        },
        
        user() {
            return this.contragent?.tender_user;
        },
        
        has_user() {
            try {
                return this.cont_id > 0;
            }
            catch (e) {
            
            }
            
            return false;
        },
        
        cont_id() {
            return parseInt(this.contragent?.id);
        },
        
    }
}
</script>


<style scoped>

</style>